module.exports = "/assets/data/5ae0b7c55ec97b99d49f561668b8a317-BT1.data.json";